<template>
    <div>

        <az-empty-state v-if="!dados" />

        <template v-else>

            <div id="repasse-prestador">

                <cabecalho-generico titulo="Repasse">
                </cabecalho-generico>

                <div class="card dashcard">
                    <div class="card-header d-flex justify-content-between">
                        <div>
                            Repasse de Honorários #{{ dados.mr.id_repasse }}
                            <span v-if="dados.mr.repasse.st_titulo">
                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                {{ dados.mr.repasse.st_titulo }}
                            </span>
                        </div>
                        <div>
                            <span v-if="dados.mr.status_repasse.nome">
                                <span class="badge mr-2" :class="'badge-' + dados.mr.status_repasse.color" >
                                    {{ dados.mr.status_repasse.nome }}
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="card-body d-flex justify-content-between">
                        <div>
                            <div class="card-text">
                                {{ dados.mr.medico.st_nome_exibicao }}
                            </div>
                            <div class="card-text">
                                Período: {{ dados.mr.repasse.periodo }}
                            </div>
                            <div v-if="dados.mr.status_repasse.code != 'AB' && dados.mr.dt_fechamento">
                                Fechamento: {{ $util.getFormatDate(dados.mr.dt_fechamento) + ' ' + dados.mr.dt_fechamento.substr(11,5)  }}
                            </div>
                        </div>

                        <div class="d-print-none">
                            <az-input 
                                sizing="sm"
                                type="button-group"
                                label="Agrupar por..."
                                :optionsList="[
                                    { id: 'R', search: 'Regra de Rateio' },
                                    { id: 'U', search: 'Unidade' },
                                    { id: 'M', search: 'Mês Produção' },
                                ]"
                                v-model="agrupar_por" />
                        </div>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item bg-dark text-white">
                            COMPOSIÇÃO
                        </li>
                    </ul>
                    <ul class="list-group list-group-flush" v-for="(lista, grupo, idx) in agrupar_items(items)" :key="idx">
                        <li class="list-group-item d-flex justify-content-between">
                            <div>
                                <a class="card-link" data-toggle="collapse" :href="'#collapse-' + idx">
                                    {{ grupo ? grupo : 'Valor' }}
                                </a>
                            </div>
                            <div>
                                <span>R$ {{ $util.formatMoeda(calctotal(lista, 'dc_valor_apurado') + calctotal(lista, 'dc_valor_consumo')) }}</span>
                                <i class="fa fa-plus-circle text-success ml-2" aria-hidden="true"></i>
                            </div>
                        </li>
                        <li class="list-group-item collapse p-0" :id="'collapse-' + idx" :class="tipo_imp == 'S' ? 'd-print-none' : ''">
                            <table class="table table-sm small">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Data</th>
                                        <th>Paciente</th>
                                        <th>Procedimento</th>
                                        <th class="text-right" v-if="!suprimir_valor">Base</th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, ix) in lista" :key="ix">
                                        <td>#{{ item.atendimento_procedimento.id_atendimento }}</td>
                                        <td>{{ $util.getFormatDate(item.atendimento_procedimento.atendimento.dt_inicio, 'DD/MM/YYYY') + 
                                                ' ' + item.atendimento_procedimento.atendimento.dt_inicio.substr(11,5) }}</td>
                                        <td>
                                            {{ item.atendimento_procedimento.atendimento.paciente.st_nome }}
                                            <small class="text-muted ml-2" v-if="item.atendimento_procedimento.plano_particular">{{ item.atendimento_procedimento.plano_particular.search }}</small>
                                            <small class="text-muted ml-2" v-else>{{ item.atendimento_procedimento.atendimento.plano.search }}</small>
                                        </td>
                                        <td>{{ item.atendimento_procedimento.procedimento.search }}</td>
                                        <td class="text-right text-muted" v-if="!suprimir_valor">
                                            {{ $util.formatMoeda(item.dc_valor_base) }}
                                        </td>           
                                        <td class="text-right">R$ {{ $util.formatMoeda(item.dc_valor_apurado + ( item.dc_valor_consumo ? item.dc_valor_consumo : 0 ) ) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>

                    </ul>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between list-group-item-primary">
                            <strong>TOTAL REPASSE</strong>
                            <strong>
                                <span>R$ {{ $util.formatMoeda(total(dados.mr.items,  'dc_valor_apurado') + total(dados.mr.items,  'dc_valor_consumo')) }}</span>
                                <i class="fa fa-circle text-primary ml-2" aria-hidden="true"></i>
                            </strong>
                        </li>
                    </ul>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between" v-for="(ajuste, iax) in dados.mr.ajustes" :key="iax">
                            <div>{{ ajuste.st_ajuste }}</div>
                            <div>
                                <span>R$ {{ $util.formatMoeda(ajuste.dc_valor_ajuste) }}</span>
                                <i class="fa fa-plus-circle text-success ml-2" v-if="!ajuste.fl_abater" aria-hidden="true"></i>
                                <i class="fa fa-minus-circle text-danger ml-2" v-if="ajuste.fl_abater" aria-hidden="true"></i>
                            </div>
                        </li>
                    </ul>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item d-flex justify-content-between list-group-item-primary">
                            <strong>
                                TOTAL
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <small class="text-muted">Valor para emissão da NF</small>
                            </strong>
                            <strong>
                                <span>R$ {{ $util.formatMoeda(dados.mr.valor_total) }}</span>
                                <i class="fa fa-circle text-primary ml-2" aria-hidden="true"></i>
                            </strong>
                        </li>

                        <template v-if="dados.mr.imposto_ajustes && dados.mr.imposto_ajustes.length">
                            <li class="list-group-item d-flex justify-content-between" v-for="(imposto, iix) in dados.mr.imposto_ajustes" :key="iix">
                                <div>
                                    {{ imposto.st_ajuste }}
                                </div>
                                <strong>
                                    <span>R$ {{ $util.formatMoeda(imposto.dc_valor_ajuste) }}</span>
                                    <i class="fa fa-minus-circle text-danger ml-2" aria-hidden="true"></i>
                                </strong>
                            </li>
                        </template>

                        <template v-if="false && dados.mr.medico.fornecedor">
                            <li class="list-group-item d-flex justify-content-between" v-for="(imposto, iix) in dados.mr.medico.fornecedor.retencoes" :key="iix">
                                <div>
                                    {{ imposto.imposto.search }}
                                    <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                    {{ $util.formatMoeda(imposto.dc_aliquota) }}%
                                </div>
                                <strong>
                                    <span>R$ {{ $util.formatMoeda(dados.mr.valor_total * ( imposto.dc_aliquota / 100 ) ) }}</span>
                                    <i class="fa fa-minus-circle text-danger ml-2" aria-hidden="true"></i>
                                </strong>
                            </li>
                        </template>
                    </ul>
                </div>

            </div>

            <div class="d-flex">

                <az-input
                    type="button-group"
                    :optionsList="[
                        { id: 'S', search: 'Sintético' }, 
                        { id: 'A', search: 'Analítico' },
                    ]" 
                    v-model="tipo_imp" />

                <button type="button" class="btn btn-outline-secondary ml-2 mb-1" @click="imprimir()">
                    <i class="fa fa-print mr-2" aria-hidden="true"></i>
                    imprimir
                </button>

            </div>

            <div class="mt-3">

                <div class="card dashcard">

                    <div class="card-header" v-if="pode_anexar">
                        Anexar PDF da Nota Fiscal
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" v-for="(arq, iax) in dados.mr.arquivos" :key="iax">
                            <a :href="arq.arquivo.temporary_url" target="_blank" class="card-link">
                                {{ arq.arquivo.st_titulo }}
                            </a>
                        </li>
                    </ul>
                    <div class="card-footer" v-if="pode_anexar">
                        <button class="btn btn-outline-primary" @click="anexar()">Anexar</button>
                    </div>
                </div>
                
                <az-file-upload
                    v-if="pode_anexar"
                    ref="upload"
                    @refresh="load(false)"
                    :multiple="true"
                    :arquivos="dados.mr.arquivos"
                    :parms="{ model_type: 'medicoRepasse', model_id: dados.mr.id_medico_repasse }" />

            </div>

            <pre v-if="false">{{ dados }}</pre>

        </template>
        
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery'; 
import AzEmptyState from '../util/AzEmptyState.vue';
import AzFileUpload from '../util/AzFileUpload.vue';
import AzInput from '../shared/forms/AzInput.vue';
import CabecalhoGenerico from '../relatorios/shared/CabecalhoGenerico.vue';

export default {
    data() { 
        return { 
            dados: null, 
            tipo_imp: 'S',
            agrupar_por: 'R',
            suprimir_valor: false, 
        }
    },

    props: [
        'id_medico_repasse', 
        'token', 
    ],

    components: { 
        AzEmptyState,
        AzFileUpload,
        AzInput,
        CabecalhoGenerico, 
    },

    computed: { 
        pode_anexar: function () { 
            if ( !this.dados )
                return false;

            return this.dados.mr.status_repasse.code == 'FC' || !this.dados.mr.arquivos.length || this.dados.anexo_livre;
        },

        items: function () { 
            if ( !this.dados )
                return [];

            return this.dados.mr.items;

            // return _.groupBy(this.dados.mr.items, item => item.rateio_medico.st_titulo);
        }
    },  

    methods: { 
        agrupar_items (items) { 
            return _.groupBy(
                items.filter(item => item.fl_ativo), 
                item => { 
                    if ( this.agrupar_por == 'U' ) { 
                        return item.atendimento_procedimento.atendimento.unidade_operacao_nome.st_nome;
                    } else if ( this.agrupar_por == 'M' ) { 
                        return item.atendimento_procedimento.atendimento.dt_inicio.substr(0,7);
                    } else { 
                        return item.rateio_medico.search;
                    }
                }
            );
        },

        total(lista, campo) { 
            return _.sumBy(lista, campo);
        },

        imprimir() { 
            this.$htmlToPaper('repasse-prestador', null, () => {
                console.log("Printing");
            });
        },

        anexar() { 
            this.$refs.upload.abrir();
        },

        calctotal(lista, campo) { 
            return _.sumBy(lista, campo);
        },

        load() { 
            $('.modal').modal('hide');

            this.$util.load(this, { 
                service: 'repasses',
                func: 'extrato_prestador',
                parms: { 
                    id_medico_repasse: this.id_medico_repasse,
                },
                configs:[
                    'repasse-suprimir-valor'
                ], 
                loadTo: res => { 
                    this.dados = res;

                    if ( this.$store.state.contexto['repasse-suprimir-valor'] > 0 ) { 
                        this.suprimir_valor = true; 
                    }
                }
            });
        }
    },

    mounted() { 
        this.load();
    }
}
</script>